module.exports = __webpack_public_path__ + "img/zoom-icon.374a7b8d.png";